import React, { useEffect, useState } from 'react'
import { pushEvent, EVENTS } from '../../utils/dataLayer'
import '../Weekly/weekly.css'

// Thank-you page for the /weekly funnel. Forwards to home after
// REDIRECT_SECONDS (or immediately via the button).

const REDIRECT_SECONDS = 5;

const isLoginDomain = () => {
  const hostname = window.location.hostname;
  const loginDomain = process.env.REACT_APP_LOGIN_DOMAIN || 'login.dastaan.info';
  return hostname === loginDomain || process.env.REACT_APP_DOMAIN === 'login';
};

const MAIN_DOMAIN_URL = process.env.REACT_APP_MAIN_DOMAIN_URL || `https://${process.env.REACT_APP_MAIN_DOMAIN || 'dastaan.info'}/`;

// Same login.dastaan.info -> dastaan.info session handoff as PaymentSuccess.
const buildHandoffUrl = () => {
  const authParams = new URLSearchParams({
    auth_token: localStorage.getItem('dastaan__token') || '',
    auth_user_id: localStorage.getItem('dastaan__user_id') || '',
    auth_phone: localStorage.getItem('dastaan__phone') || '',
    auth_name: localStorage.getItem('dastaan__name') || '',
    auth_user_image: localStorage.getItem('dastaan__user_image') || '',
    auth_plan_id: localStorage.getItem('dastaan__plan_id') || '',
    auth_plan_amnt: localStorage.getItem('dastaan__plan_amnt') || '',
    auth_plan_active: localStorage.getItem('dastaan__plan_active') || '',
  });
  return `${MAIN_DOMAIN_URL}?${authParams.toString()}`;
};

function WeeklySuccess() {
  const params = new URLSearchParams(window.location.search);
  const txnid = params.get('txnid') || '';
  const amount = params.get('amount') || localStorage.getItem('dastaan__plan_amnt') || '';

  // Purchase conversion for GTM / Google Ads (same shape as PaymentSuccess).
  useEffect(() => {
    const value = amount ? Number(amount) : undefined;
    const planId = localStorage.getItem('dastaan__plan_id');
    pushEvent(EVENTS.PURCHASE, {
      transaction_id: txnid,
      value,
      currency: 'INR',
      ecommerce: {
        transaction_id: txnid,
        value,
        currency: 'INR',
        items: [{ item_id: planId ? String(planId) : undefined, price: value, item_category: 'subscription', quantity: 1 }],
      },
    });
  }, [txnid, amount]);

  const startListening = () => {
    window.location.href = isLoginDomain() ? buildHandoffUrl() : '/';
  };

  const [seconds, setSeconds] = useState(REDIRECT_SECONDS);
  useEffect(() => {
    const redirect = setTimeout(startListening, REDIRECT_SECONDS * 1000);
    const tick = setInterval(() => setSeconds((s) => (s > 0 ? s - 1 : 0)), 1000);
    return () => {
      clearTimeout(redirect);
      clearInterval(tick);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className='weekly-page'>
      <div className='weekly-page__inner weekly-success'>
        <img
          className='weekly-page__logo'
          src={`${process.env.PUBLIC_URL}/logo/Dastaan_logo.png`}
          alt="Dastaan"
          title="Dastaan"
        />

        <div className='weekly-success__body'>
          <div className='weekly-success__check'>&#10003;</div>
          <h1 className='weekly-success__title'>Thank you!</h1>
          <p className='weekly-success__text'>
            Your payment was successful and your Weekly plan is now active. Enjoy unlimited access to Dastaan.
          </p>

          <div className='weekly-success__receipt'>
            <div className='weekly-success__row'>
              <span>Plan</span>
              <strong>Weekly</strong>
            </div>
            {txnid && (
              <div className='weekly-success__row'>
                <span>Transaction ID</span>
                <span className='weekly-success__txn'>{txnid}</span>
              </div>
            )}
          </div>

          <button type='button' className='weekly-page__cta' onClick={startListening}>
            Start Listening
          </button>
          <p className='weekly-success__redirect'>Taking you home in {seconds}s…</p>
        </div>
      </div>
    </div>
  );
}

export default WeeklySuccess
